'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';

export default class JgTotal extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.init();
    }

    init() {
        let nodeId = this.$container.data('node-id');
        if (!nodeId) {
            this.$container.addClass('js-init-errors');
            return false;
        }

        let pageTotal = this.$container.data('page-total');
        this.pageTotal = pageTotal ? parseFloat(pageTotal) : 0;

        this.$container.addClass('is-loading');

        this.baseURL = window.location.protocol + "//" + window.location.host;
        const request = this.getRequest(`${this.baseURL}/api/donation/GetTotal?nodeId=${nodeId}`);

        request.then((response) => {
            this.renderTotal(response);
        }, (error) => {
            this.renderError(error);
        }).then(() => {
            this.$container.removeClass('is-loading');
        });
    }

    renderTotal(response) {
        let amount = this.pageTotal + parseFloat(response);
        let amountStr = amount.toFixed(2);
        let content = `£${amountStr}`;
        this.$container.html(content);
    }

    renderError(error) {
        console.log(error);
        this.$container.html(`
            <div class="jg-error__container">
                <span class="jg-error">Sorry, we were unable to retrieve data. Please try again later.</span>
            </div>
        `);
    }

    getRequest(url) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                contentType: 'application/json'
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/jg-total/js/generic.jg-total.js